import { useEffect, useState } from 'react';
import Header from '../componets/Layout/Header';
import Sidebar from '../componets/Layout/Sidebar';
import TemplateTable from '../componets/Template/TemplateTable';
import { getAllTemplate, getTemplateList } from '../controller';
import { requestHandler } from '../helper';

function Template() {

  const [tempData, setTempData] = useState([]);
  let perPage = 10;
  const [page, setPage] = useState(1);
  const [paginationValue, setPaginationValue] = useState();
  const [searchQuery, setSearchQuery] = useState('');
  const [fileType, setFileType] = useState('');
  const [status, setStatus] = useState("");
  const [categoryId, setCategoryId] = useState("");
  const [allData, setAllData] = useState([]);

  const [templateId, setTemplateId] = useState("");

  const getAllTemplateData = async () => {
    await requestHandler(
      async () => await getAllTemplate(page, perPage, searchQuery, status, categoryId, fileType, templateId),
      null,
      (res) => {
        setTempData(res.data.templates);
        setPage(res.data.page);
        setPaginationValue(res.data.paginationValue);
      },
      () => { }
    );
  }

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      getAllTemplateData();
    }, 500);
    return () => clearTimeout(delayDebounceFn);
  }, [searchQuery, page, status, categoryId, fileType, templateId]); // 

  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
    setPage(1); // Reset to the first page when search changes
  };

  const handleStatusChange = (newValue) => {
    setStatus(newValue);
    setPage(1);
  }

  const handleCategoryIdChange = (newValue) => {
    setCategoryId(newValue);
    setPage(1);
  }

  const handleTemplateIdChange = (newValue) => {
    setTemplateId(newValue);
    setPage(1);
  }

  const handleFileTypeChange = (newValue) => {
    setFileType(newValue);
    setPage(1);
  }


  const getAllTemplates = async () => {
    await requestHandler(
      async () => await getTemplateList(),
      null,
      (res) => {
        setAllData(res.data.templates);
      },
      () => { }
    );
  }

  useEffect(() => {
    getAllTemplates();
  }, []); // 

  return (
    <>
      <div className='layouy-main'>
        <div className='sidebar-hide-show'>
          <Sidebar />
        </div>
        <div className='w-100'>
          <Header />
          <div className="tebs-title">
            <p className='active'>Template Management</p>
          </div>
          <section>
            <div className="card main-card">
              <div className="card-body px-0 pt-0">
                <div className="table-main">
                  <div className="card">
                    <div className="card-body">
                      <div className='tables-container'>
                        <div>
                          <TemplateTable tempData={tempData} searchQuery={searchQuery} handleSearchChange={handleSearchChange} perPage={perPage} page={page} setPage={setPage} getAllTemplateData={getAllTemplateData} onStatusChange={handleStatusChange} onCategoryIdChange={handleCategoryIdChange} onFileTypeChange={handleFileTypeChange} onTemplateIdChange={handleTemplateIdChange} allData={allData} paginationValue={paginationValue} />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </>
  )
}

export default Template